/**
 * Validate if product is ready for passenger step
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct(to);
    const { firstStepRoute } = useFlow(to);

    if (product.value.config.type === 'Activity') {
        const productActivity = product.value as ProductActivity;
        if (!productActivity.dateFrom || !productActivity.dateUntil) {
            return navigateTo(firstStepRoute.value);
        }
    }
    else if (product.value.config.type === 'P2P') {
        const productP2P = product.value as ProductP2P;
        if (productP2P.isRoundtrip === true
            && (!productP2P.tripUp || !productP2P.tripDown)) {
            return navigateTo(firstStepRoute.value);
        }

        if (!productP2P.isRoundtrip && !productP2P.tripUp) {
            return navigateTo(firstStepRoute.value);
        }
    }
    else if (product.value.config.type === 'Accommodation') {
        const productAccommodation = product.value as ProductAccommodation;
        if (!productAccommodation.dateFrom || !productAccommodation.dateUntil) {
            return navigateTo(firstStepRoute.value);
        }
    }
});
